import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IReport } from './report.service';
import { UserService } from './user.service';

@Injectable({
	providedIn: 'root',
})
export class MenuService {
	private reportFocusSubject$: BehaviorSubject<IReport | null>;
	public reportFocus$: Observable<IReport | null>;
	private reportSelectSubject$: BehaviorSubject<IReport | null>;
	public reportSelect$: Observable<IReport | null>;
	public reportCategoryBeingIterated: any = '';

	constructor(private userService: UserService) {
		this.reportFocusSubject$ = new BehaviorSubject<IReport | null>(null);
		this.reportFocus$ = this.reportFocusSubject$.asObservable();
		this.reportSelectSubject$ = new BehaviorSubject<IReport | null>(null);
		this.reportSelect$ = this.reportSelectSubject$.asObservable();

		this.userService.accountChanged$.subscribe(() => {
			this.reportFocusSubject$.next(null);
			this.reportSelectSubject$.next(null);
		});
	}

	public get reportFocus(): IReport | null {
		return this.reportFocusSubject$.value || null;
	}

	public set reportFocus(v: IReport | null) {
		if (this.reportFocus?.id !== v?.id) {
			this.reportFocusSubject$.next(v);
		}
	}

	public get reportSelect(): IReport | null {
		return this.reportSelectSubject$.value || null;
	}

	public set reportSelect(v: IReport | null) {
		if (v?.reportId) {
			if (this.reportSelect?.reportId !== v?.reportId) {
				this.reportSelectSubject$.next(v);
			}
		} else {
			if (v?.externalUrlId) {
				if (this.reportSelect?.reportId !== v?.externalUrlId) {
					this.reportSelectSubject$.next(v);
				}
			} else {
				if (this.reportSelect?.id !== v?.id) {
					this.reportSelectSubject$.next(v);
				}
			}
		}
	}
}
